import { Route } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import ProtectedRouteV2 from "./ProtectedRouteV2";

// 📄 Pages
import PriceListPage from "../pages/PriceLists/PriceListPage";
import PriceListProductAssignmentPage from "../pages/PriceLists/PriceListProductAssignmentPage";

const priceListRoutes = (
  <Route element={<ProtectedRouteV2 />}>

    {/* 📌 Listas de Precios */}
    <Route
      path="/catalog/price-lists"
      element={
        <>
          <PageTitle title="Listas de Precios | Codenova POS" />
          <PriceListPage />
        </>
      }
    />

    {/* 🔗 Asignación de Productos */}
    <Route
      path="/catalog/price-lists/products"
      element={
        <>
          <PageTitle title="Asignación a Productos | Codenova POS" />
          <PriceListProductAssignmentPage />
        </>
      }
    />

  </Route>
);

export default priceListRoutes;
